/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftDatePicker from "components/SoftDatePicker";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable3({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      index: "1",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: 0,
      value16: 0,
      value17: 0,
      value18: 0,
      value19: 0,
      value20: 0,
      value21: 0,
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: 0,
      value16: 0,
      value17: 0,
      value18: 0,
      value19: 0,
      value20: 0,
      value21: 0,
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">I. CHUYỂN NHƯỢNG VỐN GÓP</Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center" }}>
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td colSpan={3} style={{ textAlign: "center" }}>
                Thông tin cá nhân chuyển nhượng
              </Td>
              <Td colSpan={3} style={{ textAlign: "center" }}>
                Thông tin tổ chức, cá nhân nhận chuyển nhượng
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Hợp đồng chuyển nhượng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Giá chuyển nhượng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Giá vốn của phần vốn góp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Chi phí chuyển nhượng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thu nhập tính thuế từ chuyển nhượng vốn góp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNCN phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế được miễn giảm theo Hiệp định tránh đánh thuế hai lần
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế còn phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Họ và tên (*)</Td>
              <Td style={{ textAlign: "center" }}>Mã số thuế</Td>
              <Td style={{ textAlign: "center" }}>
                Số CMND/Hộ chiếu/CCCD(trường hợp chưa có mã số thuế)
              </Td>
              <Td style={{ textAlign: "center" }}>Tên tổ chức, cá nhân</Td>
              <Td style={{ textAlign: "center" }}>Mã số thuế</Td>
              <Td style={{ textAlign: "center" }}>
                Số CMND/Hộ chiếu/CCCD(trường hợp chưa có mã số thuế)
              </Td>
              <Td style={{ textAlign: "center" }}>Số</Td>
              <Td style={{ textAlign: "center" }}>Ngày/tháng/năm</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[06]</Td>
              <Td style={{ textAlign: "center" }}>[07]</Td>
              <Td style={{ textAlign: "center" }}>[08]</Td>
              <Td style={{ textAlign: "center" }}>[09]</Td>
              <Td style={{ textAlign: "center" }}>[10]</Td>
              <Td style={{ textAlign: "center" }}>[11]</Td>
              <Td style={{ textAlign: "center" }}>[12]</Td>
              <Td style={{ textAlign: "center" }}>[13]</Td>
              <Td style={{ textAlign: "center" }}>[14]</Td>
              <Td style={{ textAlign: "center" }}>[15]</Td>
              <Td style={{ textAlign: "center" }}>[16]</Td>
              <Td style={{ textAlign: "center" }}>[17]</Td>
              <Td style={{ textAlign: "center" }}>[18]=[15]-[16]-[17]</Td>
              <Td style={{ textAlign: "center" }}>[19]=[18]*20%</Td>
              <Td style={{ textAlign: "center" }}>[20]</Td>
              <Td style={{ textAlign: "center" }}>[21]=[19]-[20]</Td>
            </tr>

            {data.map((item, index) => {
              return (
                <tr key={item.id}>
                  <Td className="toggle-button" style={{ textAlign: "center" }}>
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete(item.id)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value7"
                      type="text"
                      value={item.value7}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value8"
                      type="text"
                      value={item.value8}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value9"
                      type="text"
                      value={item.value9}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value10"
                      type="text"
                      value={item.value10}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value11"
                      type="text"
                      value={item.value11}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value12"
                      type="text"
                      value={item.value12}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value13"
                      type="text"
                      value={item.value13}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <DatePicker
                      style={{
                        fontSize: 13,
                        color: "#495057",
                        border: "0.0625rem solid #d2d6da",
                        background: "#fff",
                        padding: "0.5rem 0.75rem",
                        width: "100%",
                        borderRadius: "0.5rem",
                      }}
                      options={{
                        locale: Vietnamese,
                        time_24hr: true,
                        dateFormat: "d-m-Y",
                        enableTime: true,
                      }}
                      name="value14"
                      onChange={(e) => setFieldValue("value14", e[0])}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value15"
                      value={item.value15}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value16"
                      value={item.value16}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value17"
                      value={item.value17}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
                  <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value20"
                      value={item.value20}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
                </tr>
              );
            })}
            <tr>
              <Td colSpan={4} style={{ textAlign: "center", background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable3);

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type ?? "text"}
      style={{
        textAlign: type && type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
